export const LOGIN_PAGE_PATH = '/entrar'
export const HOME_PAGE_PATH = '/'
export const DASHBOARD_PAGE_PATH = '/carteira'
export const SALES_PAGE_PATH = '/carteira/vender'
export const WALLET_PAGE_PATH = '/carteira/*'
export const VERIFIY_CPF_PAGE_PATH = '/verificar/cpf'
export const CUSTOMER_REGISTER_PAGE_PATH = '/cliente/registrar'
export const QRCODE_PAGE_PATH = '/pagamento/pix/qrcode'
export const SUCCESS_PAGE_PATH = '/pagamento/sucesso'
export const FAQ_PAGE_PATH = '/carteira/ajuda'